















































































































import { Meta } from "@/store/meta"
import { Component } from "vue-property-decorator"
import { Server, Partner } from '@/store/server'
import { getModule } from "vuex-module-decorators"
import ConfirmModal from '@/components/ConfirmModal.vue'
import AlertModal from '@/components/AlertModal.vue'
import { mixins } from "vue-class-component"
import { DateTime } from "@/mixins/datetime"

@Component({
  components: {
      'confirm-modal': ConfirmModal,
      'alert-modal': AlertModal
  }
})
export default class Contact extends mixins(DateTime) {
  inputService = ''
  inputDatetime = new Date()
  inputTitle = ''
  inputContent = ''
  checkContents = [{}]
  isConfirmModalActive = false
  isAlertModalActive = false
  alertContent = ''
  timing = '' // immediate or reserve
  isImmediate = false
  title = ''
  weekArray = ['日', '月', '火', '水', '木', '金', '土']
  partners: Partner[] = []
  partnersLoading = false
  selectedPartnerCodes: string[] = []


  get meta() {
    return getModule(Meta)
  }

  get isPrivileged() {
    return this.server.loginInfo.privileged
  }

  get server() {
    return getModule(Server)
  }

  get xChannelServices() {
    const channel = getModule(Server).boccoChannel
    return channel == null ? [] : channel.services
  }

  async mounted() {
    this.timing = `${this.$route.query.timing}`
    if(this.timing == 'immediate'){
      this.isImmediate = true
      this.title = '配信 - 即時配信'
    }else{
      this.isImmediate = false
      this.title = '配信 - 予約配信'
    }

    await getModule(Server).getBoccoChannel()

    if (this.xChannelServices.length > 0) {
      this.inputService = this.xChannelServices[0].uuid
    }

    // 特権ユーザーの場合、パートナー一覧を取得
    if (this.isPrivileged) {
      this.partnersLoading = true
      try {
        this.partners = await this.server.getPartners()
      } catch (e) {
        console.warn('failed to fetch partners', e)
      } finally {
        this.partnersLoading = false
      }
    }
  }

  alertModal(alertContent = ''){
    this.alertContent = alertContent
    this.isAlertModalActive = true
  }

  partnerLabel(partner: Partner): string {
    return partner.memo ? `${partner.code} (${partner.memo})` : partner.code
  }

  postBroadcastMessagesCheck(){
    if(!this.inputService){
      this.alertModal('サービス名を選択してください。')
      return
    }else if(!this.inputTitle){
      this.alertModal('配信名を選択してください。')
      return
    }else if(!this.inputContent){
      this.alertModal('配信メッセージを入力してください。')
      return
    }else if(!this.isImmediate && this.inputDatetime < new Date()){
      this.alertModal('配信日時に過去の時刻が入力されています。配信日時は現在時刻よりも未来の時刻を入力してください。')
      return
    }

    this.checkContents.splice(0)
    if(!this.isImmediate){
      this.checkContents.push({title:'配信日時', value: this.dateInstanceToLongDate(this.inputDatetime)})
    }
    if (this.isPrivileged && this.selectedPartnerCodes.length > 0) {
      const selectedLabels = this.selectedPartnerCodes.map(code => {
        const p = this.partners.find(p => p.code === code)
        return p ? this.partnerLabel(p) : code
      })
      this.checkContents.push({title:'パートナー絞り込み', value: selectedLabels.join(', ')})
    }
    this.checkContents.push({title:'配信名', value: this.inputTitle})
    this.checkContents.push({title:'配信メッセージ', value: this.inputContent})

    this.isConfirmModalActive = true
    return
  }

  async postBroadcastMessages(){
    // eslint-disable-next-line
    const sendData: any = {
      data:{
        title: this.inputTitle,
        text: this.inputContent,
        immediate: this.isImmediate,
        // eslint-disable-next-line
        executed_at:  Math.floor(this.inputDatetime.getTime()/1000)
      },
      // eslint-disable-next-line
      x_channle_user: this.inputService
    }
    if (this.isPrivileged && this.selectedPartnerCodes.length > 0) {
      // eslint-disable-next-line
      sendData.data.partner_codes = this.selectedPartnerCodes
    }

    try {
      let message = ''
      if (this.isImmediate){
        message = '即時配信の設定が完了しました。'
      }else{
        message = '予約配信の設定が完了しました。'
      }

      await this.server.postBroadcastMessages(sendData)
      this.$buefy.toast.open({
                    duration: 5000,
                    message: message,
                    type: 'is-link'
                })
      this.$router.push({ path: '/messages'});
    } catch (e) {
      this.$buefy.toast.open({
                    duration: 10000,
                    message: '送信に失敗しました。大変お手数ですが、しばらくお待ちいただいた後に、再度送信をお願いします。',
                    type: 'is-danger'
                })
    }
  }
}
